import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import clsx from "clsx";
import Logo from "../../components/header/Logo";
import NavMenu from "../../components/header/NavMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import { useStoreInfo } from "../../hooks/storeInfoHooks/useStoreInfo";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HeaderOne = ({
  layout,

  headerPaddingClass,
  headerPositionClass,
  headerBgClass,
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);
  const { data: storeInfo, isLoading: isLoadingStoreInfo } = useStoreInfo();

  useEffect(() => {
    const header = document.querySelector(".sticky-bar");
    setHeaderTop(header.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };

  return (
    <header
      className={clsx(
        "header-area clearfix header-modern z-5 container",
        headerBgClass,
        headerPositionClass
      )}
    >
      <div
        className={clsx(
          headerPaddingClass,
          "sticky-bar header-res-padding header-modern-bar clearfix",
          scroll > headerTop && "stick container"
        )}
      >
        <div className="">
          <div className="header-modern-wrapper">
            {/* Logo */}
            <div className="header-modern-logo">
              {isLoadingStoreInfo ? (
                <Skeleton height={"50px"} width={"50px"} circle />
              ) : (
                <Logo
                  imageUrl={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                    storeInfo?.[0]?.logo
                  }`}
                  logoClass="logo-modern"
                  width="50px"
                  height="50px"
                />
              )}
            </div>

            {/* Navigation */}
            <div className="header-modern-nav d-none d-lg-block">
              <NavMenu />
            </div>

            {/* Icons Group */}
            <div className="header-modern-icons d-none d-xl-block">
              <IconGroup />
            </div>

            {/* Mobile Menu Button */}
            <button
              className="header-mobile-menu-btn d-block d-xl-none"
              onClick={triggerMobileMenu}
              aria-label="Open mobile menu"
            >
              <i className="pe-7s-menu"></i>
            </button>
          </div>
        </div>
        {/* mobile menu */}
        <MobileMenu />
      </div>
    </header>
  );
};

HeaderOne.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string,
};

export default HeaderOne;
